import React from "react";
import { Button } from "@raspberrypifoundation/design-system-react";

const ToastCloseButton = ({ closeToast }) => {
  return <Button icon="close" onClick={closeToast} type="tertiary" />;
};

export default ToastCloseButton;
